/* ============================================
   验证处理 Mixin
   ============================================
   包含通用的验证和处理逻辑
   用于减少代码重复，便于维护
   ============================================ */

export default {
  methods: {
    /**
     * 通用的验证和处理方法
     * @param {Object} config - 配置对象
     * @param {string} config.value - 要验证的值
     * @param {Function} config.validator - 验证函数，返回 true 表示验证通过
     * @param {string} config.errorProperty - 错误属性名称（如 'usernameError'）
     * @param {string} config.errorMessage - 错误消息（可选）
     * @param {Function} config.onSuccess - 验证成功后的回调函数
     * @param {Function} config.onError - 验证失败后的回调函数（可选）
     * @returns {boolean} 验证是否通过
     */
    validateAndHandle(config) {
      const {
        value,
        validator,
        errorProperty,
        errorMessage,
        onSuccess,
        onError
      } = config;

      // 执行验证
      if (!validator(value)) {
        if (errorProperty && this[errorProperty] !== undefined) {
          this[errorProperty] = true;
        }
        if (errorMessage) {
          this.errorMessage = errorMessage;
        }
        if (onError) {
          onError();
        }
        return false;
      }

      // 验证通过
      if (errorProperty && this[errorProperty] !== undefined) {
        this[errorProperty] = false;
      }
      if (errorMessage !== undefined) {
        this.errorMessage = '';
      }
      if (onSuccess) {
        onSuccess();
      }
      return true;
    }
  }
};

